import {RegistrationTableRowData} from 'notebook/integrations/registry/SchemaInterfaceColumnTransformerBase';
import {ImplementedStaticSchemaInterfaceGQL} from 'notebook/structured-tables/components/modals/RegistrationTableInsertModal';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {makeStructuredTableColumn} from 'notebook/structured-tables/util/StructuredTableColumnUtil';
import {TableColumnType} from 'notebook/tables/TableConstants';

import ComplexPolymerRegTableColumnTransformerBase from '../ComplexPolymerRegTableColumnTransformerBase';

export default class OligoDuplexRegTableColumnTransformer extends ComplexPolymerRegTableColumnTransformerBase {
  getNewColumns(
    implementedSchemaInterface: ImplementedStaticSchemaInterfaceGQL,
    tableRowData: RegistrationTableRowData
  ): Array<StructuredTableColumn> {
    // TODO (BNCH-99575): Add offset column when bioentity already exists - need a resolution path for the
    // offset first.
    return tableRowData.bioentityExists
      ? []
      : [
          ...super.getNewColumns(implementedSchemaInterface, tableRowData),
          makeStructuredTableColumn({
            columnType: TableColumnType.OLIGO_DUPLEX_OFFSET,
            name: 'Forward offset',
            isReadOnly: false,
            isRequired: true,
          }),
        ];
  }
}
